import { SafePromise } from '@benzinga/safe-await';
import { proxyPath, RestfulClient, Session } from '@benzinga/session';
import { TrendingTopic } from '../entities';
import { TrendingTopicsEnvironment } from '../environment';
import { trendingTopicsRoutes } from './routes';
import { TrendingTopicsTransport } from './types';
import { TrendingTopicsUpstreamRestful } from './upstream';

export class TrendingTopicsProxyRestful extends RestfulClient implements TrendingTopicsTransport {
  private upstream: TrendingTopicsUpstreamRestful;

  constructor(session: Session) {
    super(session.getEnvironment(TrendingTopicsEnvironment).proxyUrl, session, {
      authorizationSession: true,
      'x-device-key': true,
    });
    this.upstream = new TrendingTopicsUpstreamRestful(session);
  }

  getTrendingTopics = (): SafePromise<TrendingTopic[]> => {
    const url = this.URL(proxyPath(trendingTopicsRoutes.topics.proxy));
    return this.get<TrendingTopic[]>(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  getTrendingIndiaTopics = (): SafePromise<TrendingTopic[]> => this.upstream.getTrendingIndiaTopics();
}
